<script>
  import { mapState, mapGetters } from 'vuex'
  import http from '@/service/http'
  import moment from 'moment'

  moment.locale('pt-br')

  export default {
    name: 'contatos-orcamentos',
    data () {
      return {
        inicio: moment().format('YYYY-MM-01'),
        termino: moment().format('YYYY-MM-DD'),
        contatos: [],
        orcamentos: [],
        valores: []
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        const {data} = await http.post(`/orcamentos/relatorios/contatos-orcamentos`, {inicio: this.inicio, termino: this.termino})
        this.contatos = data.contatos
        this.orcamentos = data.orcamentos
        this.valores = data.valores
      },
      formatDate (date) {
        return moment(date).format('DD/MM HH:mm')
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      api_url () {
        return process.env.API_URL
      }
    }
  }
</script>

<template>
  <div>
    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Relatórios Contatos X Orçamentos</h5>
        </div>
      </div>

      <form @submit.prevent="fetch" class="row">
        <div class="row">
          <h6>Contatos X Orçamentos</h6>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_inicio" type="date"  v-model="inicio" :data-value="inicio">
            <label for="icon_inicio" class="active">Início</label>
          </div>

          <div class="input-field col s12 m2">
            <i class="material-icons prefix">event</i>
            <input id="icon_termino" type="date" v-model="termino"
                   :data-value="termino">
            <label for="icon_termino" class="active">Término</label>
          </div>
          <div class="input-field col s12 m5">
            <button class="btn">Filtrar</button>
          </div>

        </div>
      </form>

      <div class="row z-depth-1">
        <div class="col s12">
          <br />
          <strong>Contatos</strong>
        </div>
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>Total no Período</th>
              <th>Novo</th>
              <th>Em Contato</th>
              <th>Finalizado com Orçamento</th>
              <th>Finalizado sem Orçamento</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                    {{ contatos[0] ? contatos[0] : 0 }}
                </td>
                <td>
                  <router-link :to="{ name: 'contatos.index', params:{status: 'Novo'} }" target="_blank">
                    {{ contatos[1] ? contatos[1] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'contatos.index', params:{status: 'Em Contato'} }" target="_blank">
                    {{ contatos[2] ? contatos[2] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'contatos.index', params:{status: 'Finalizado com Orçamento'} }" target="_blank">
                    {{ contatos[3] ? contatos[3] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'contatos.index', params:{status: 'Finalizado sem Orçamento'} }" target="_blank">
                    {{ contatos[4] ? contatos[4] : 0 }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row z-depth-1">
        <div class="col s12">
          <br />
          <strong>Orçamentos</strong>
        </div>
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>Total no Período</th>
              <th>Novo</th>
              <th>Aguardando Visita</th>
              <th>Proposta Enviada</th>
              <th>Em Negociação</th>
              <th>Aprovado</th>
              <th>Reprovado</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>R$ {{ valores[0] ? valores[0] : 0 }}</td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'novo'} }" target="_blank">
                    R$ {{ valores[1] ? valores[1] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'Aguardando Visita'} }" target="_blank">
                    R$ {{ valores[2] ? valores[2] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'Proposta Enviada'} }" target="_blank">
                    R$ {{ valores[3] ? valores[3] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'Em Negociação'} }" target="_blank">
                    R$ {{ valores[4] ? valores[4] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'Aprovado'} }" target="_blank">
                    R$ {{ valores[5] ? valores[5] : 0 }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ name: 'orcamentos.index', params:{status: 'Reprovado'} }" target="_blank">
                    R$ {{ valores[6] ? valores[6] : 0 }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/relatorios/contatosOrcamentos.vue